import { Suspense, useState } from "react";

import { useStandardProductContext } from "app/providers/StandardProductProvider";
import Card from "shared/ui/card";
import { concatClassnames } from "shared/utils/concatClassnames";
import DoorOptions from "widgets/configurator/door-options";
import DoorOptionsFooter from "widgets/configurator/door-options-footer";
import StandardProductOptions from "widgets/configurator/standard-product-options";
import StandardProductOptionsFooter from "widgets/configurator/standard-product-options-footer";
import WhatsAppCard from "widgets/shared/whatsapp-widget/WhatsAppCard";
import { DoorOptionsUSPHeader } from "../door-options-usp-header";
import OptionModal, { OptionModalState } from "../option-modal";

interface ConfiguratorOptionsProps {
  className?: string;
}
const ConfiguratorOptions = ({ className = "" }: ConfiguratorOptionsProps) => {
  const { showStandardProducts, store: standardProduct } =
    useStandardProductContext();
  const [optionModalState, setOptionModalState] = useState<OptionModalState>({
    isOpen: false,
    heading: "",
    description: "",
  });

  const hideStandardProductFooter =
    standardProduct?.selectedStandardProductCategory?.code.includes(
      "kleurstaal",
    );

  return (
    <Suspense fallback={null}>
      <section className={concatClassnames(className)}>
        <Card className="custom-scroll-container gg-relative">
          {showStandardProducts ? (
            <>
              <StandardProductOptions
                setOptionModalState={setOptionModalState}
              />

              {!hideStandardProductFooter && <StandardProductOptionsFooter />}
            </>
          ) : (
            <>
              <div className="gg-hidden sm:gg-block">
                <DoorOptionsUSPHeader />

                <WhatsAppCard />
              </div>

              <DoorOptions setOptionModalState={setOptionModalState} />
              <footer className="gg-sticky gg-bottom-0">
                <DoorOptionsFooter />
              </footer>
            </>
          )}
        </Card>

        <OptionModal
          modalState={optionModalState}
          setModalState={setOptionModalState}
        />
      </section>
    </Suspense>
  );
};
export default ConfiguratorOptions;
